module.exports = __webpack_public_path__ + "static/media/aveo.9426eb5c.svg";